import React from "react";
import { Formik } from "formik";
import { TextField, DialogActions, DialogContent, FormGroup, withStyles, Button, CircularProgress, FormControlLabel, Checkbox } from "@material-ui/core";
import * as Yup from "yup";

const styles = theme => ({

    buttonSafe: {
        '&:hover': {
            color: theme.palette.buttonText.default,
            backgroundColor: theme.palette.secondary.main,
        },
        width: "45%",
    },
    buttonDanger: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "45%",
    },
    formControl: {
        width: "40%",
        marginRight: '72%'
    },
    formControlLabel: {
        marginLeft: 0
    }
});

const TypicalProblemForm = props => {
    const { classes, formSettings, initialValues, modalState, handleSubmit, translations, handleCloseSafe } = props;
    return (
        <>
            <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                enableReinitialize={true}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit } = formikProps;
                    return (
                        <>
                            <form onSubmit={handleSubmit}>
                                <DialogContent>
                                    <FormGroup >
                                        <FormControlLabel
                                            control={<Checkbox checked={values.favorite} name="favorite" onChange={handleChange} color="primary" />}
                                            label={translations["favorite"] || "Favorite"}
                                            labelPlacement="end"
                                        />
                                        <FormControlLabel
                                            control={<Checkbox checked={values.default} name="default" onChange={handleChange} color="primary" />}
                                            label={translations["default"] || "Default"}
                                            labelPlacement="end"
                                        />
                                        <FormControlLabel
                                            className={classes.formControlLabel}
                                            control={<TextField
                                                id={`TP_${modalState.data.TypicalProblemID}`}
                                                placeholder={translations["key"] || "key"}
                                                value={values.hotKey}
                                                onBlur={handleBlur}
                                                error={!!(errors.hotKey && touched.hotKey)}
                                                onChange={handleChange}
                                                type="number"
                                                onInput={(e) => {
                                                    e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 1)
                                                }}
                                                name='hotKey'
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                className={classes.formControl}
                                                inputProps={{ min: "0", max: "9", step: "1" }}
                                            />}
                                            label={`ctrl+ `}
                                            labelPlacement="start"
                                        />
                                    </FormGroup>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleCloseSafe} variant="contained" className={classes.buttonSafe}>
                                        {translations['cancel'] || 'Cancel'}
                                    </Button>
                                    <Button
                                        className={classes.buttonDanger}
                                        variant="contained"
                                        color={formSettings.ButtonSubmit.Color}
                                        type="submit"
                                        style={{ color: isSubmitting || !(isValid && dirty) ? null : 'white' }}
                                        disabled={isSubmitting || !(isValid && dirty)}
                                    >
                                        {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                </DialogActions>
                            </form>
                        </>);
                }}
            </Formik>
        </ >
    );
};
export default withStyles(styles, { withTheme: true })(TypicalProblemForm);
